import { WindowedObservable } from "./lib/windowed-observable";

export interface EnvConfig {
  GTM_KEY: any;
  BACKCHECK_REQUEST_URL: string;
  AZURE_CLIENT_ID: string;
  AZURE_AUTHORITY: string;
  AZURE_REDIRECT_URI: string;
  AZURE_WEB_API_SCOPE: string;
}

const dev: EnvConfig = {
  BACKCHECK_REQUEST_URL: process.env.BACKCHECK_REQUEST_URL ??
    'https://localhost:7171',
  AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID ?? '3c3fd76a-76c2-4ee9-8db0-5e0388575521',
  AZURE_AUTHORITY: process.env.REACT_APP_AZURE_AUTHORITY ?? 'https://login.microsoftonline.com/8d195b37-4c12-4f37-b356-c0d6a39b46a1',
  AZURE_REDIRECT_URI: process.env.REACT_APP_AZURE_REDIRECT_URI ?? 'http://localhost:3000/',
  AZURE_WEB_API_SCOPE: process.env.REACT_APP_AZURE_WEB_API_SCOPE ?? 'https://vmsfeedsapi-teamprocom.msappproxy.net//user_impersonation',
  GTM_KEY: process.env.GTM_KEY || 'GTM-5JVF36B'
};

const ci: EnvConfig = {
  BACKCHECK_REQUEST_URL:  '#{BACKCHECK_REQUEST_URL}#',
  AZURE_CLIENT_ID: '#{AZURE_CLIENT_ID}#',
  AZURE_AUTHORITY: '#{AZURE_AUTHORITY}#',
  AZURE_REDIRECT_URI: '#{AZURE_REDIRECT_URI}#',
  AZURE_WEB_API_SCOPE: '#{AZURE_WEB_API_SCOPE}#',
  GTM_KEY: '#{GTM_KEY}#'
};

// export const environment: EnvConfig =
//   process.env.REACT_APP_STAGE === 'ci' ? ci : dev;

// Optional: Publish to window for global access (if needed)
export const environment = {
  ...(process.env.REACT_APP_STAGE === 'ci' ? ci : dev),
}

new WindowedObservable("Environment").publish(environment)